/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * Resend Invoices Input Action
 */
export class ResendInvoicesInput implements Msdyn365.IActionInput {
    public invoices: string;
    constructor(invoices: string) {
        this.invoices = invoices;
    }
    public getCacheKey = () => `DEFAULT + ${this.invoices} ${new Date()}`;
    public getCacheObjectType = () => `IResendInvoicesData  ${new Date()}`;
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export interface IResendInvoicesData {
    response: boolean;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new ResendInvoicesInput('');
};

async function action(input: ResendInvoicesInput, ctx: Msdyn365.IActionContext): Promise<IResendInvoicesData> {
    let result: boolean = false;

    await Msdyn365.sendRequest(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/TecResendInvoicesViaEmail`,
        'post',
        {
            invoices: input.invoices
        },

        {
            headers: { OUN: ctx.requestContext.apiSettings.oun, Authorization: `id_token ${ctx.requestContext.user.token}` },
            timeout: 30000
        }
    ).then(res => {
        result = (res?.data as any)?.value;
    });

    // TODO: When Backend fixed error, remove
    if (!result) {
        return { response: true };
    }
    return { response: result };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IResendInvoicesData>>action,
    id: 'TecResendInvoicesViaEmail',
    input: createInput
});
